import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

export function formatSlot(iso) {
    return dayjs(iso).format('h:mm A');
}

export function formatDate(iso) {
    return dayjs(iso).format('ddd, MMM D, YYYY');
}

export function formatDateTime(iso) {
    return dayjs(iso).format('ddd, MMM D · h:mm A');
}

export function fromNow(iso) {
    return dayjs(iso).fromNow();
}

export function getTimezoneShort() {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const offsetMin = new Date().getTimezoneOffset();
    const sign = offsetMin <= 0 ? '+' : '-';
    const hh = String(Math.floor(Math.abs(offsetMin) / 60)).padStart(2, '0');
    const mm = String(Math.abs(offsetMin) % 60).padStart(2, '0');
    return `${tz} (UTC${sign}${hh}:${mm})`;
}

export function groupSlotsByDay(slots) {
    const map = {};
    for (const s of slots) {
        const key = dayjs(s.start).format('YYYY-MM-DD');
        if (!map[key]) map[key] = [];
        map[key].push(s);
    }
    return map;
}

export function groupSlotsByPart(slots) {
    const groups = { morning: [], afternoon: [], evening: [] };
    for (const s of slots) {
        const hour = dayjs(s.start).hour();
        if (hour < 12) groups.morning.push(s);
        else if (hour < 17) groups.afternoon.push(s);
        else groups.evening.push(s);
    }
    return groups;
}
